import React from 'react';
import { Compass } from 'lucide-react';
import GphRichBlock from '../GphRichBlock';
import { GPH_COPY } from '../../../services/gph/gphCopy';
import { getOntology, getGameLabel } from '../../../services/gph/gphGameOntology';

export default function FallbackExpertAdapter({ agent, context = {} }) {
  const game = context.game || agent.host.canonicalGame || 'pubg_mobile';
  const ontology = getOntology(game);
  const gameLabel = getGameLabel(game);

  return (
    <GphRichBlock
      eyebrow="Coach FPS Mobile"
      title="Vamos direto ao ponto"
      subtitle={GPH_COPY.fallbackExpertNotice}
    >
      <div className="space-y-6 pt-2 text-left">
        <p className="text-sm text-slate-300 leading-relaxed m-0 font-sans">
          O que você quer melhorar em {gameLabel} hoje? Mira, movimentação ou tática? Me diga e eu crio o treino.
        </p>
        
        {ontology && (
          <div className="border-l-2 border-slate-700 pl-4 py-1">
            <p className="text-xs text-slate-400 leading-relaxed m-0 flex items-start gap-2 font-mono">
              <Compass size={14} className="text-lime-400 shrink-0 mt-0.5" />
              <span>
                Domínio de {gameLabel}: {ontology.aimTerms.slice(0, 3).join(', ')}, {ontology.movementTerms.slice(0, 2).join(', ')} e {ontology.combatTerms.slice(0, 2).join(', ')}.
              </span>
            </p>
          </div>
        )}
        
        <div className="gph-block-actions pt-2">
          <button
            type="button"
            className="gph-btn gph-btn--primary text-xs"
            onClick={() => agent.runCapability('sensitivity_diagnostic', {})}
          >
            Diagnosticar sensibilidade
          </button>
          <button
            type="button"
            className="gph-btn gph-btn--ghost text-xs"
            onClick={() => agent.askAnotherDrill()}
          >
            Gerar treino
          </button>
          <button
            type="button"
            className="gph-btn gph-btn--ghost text-xs"
            onClick={() => agent.runCapability('mi_analysis_gameplay', {})}
          >
            Analisar gameplay
          </button>
        </div>
      </div>
    </GphRichBlock>
  );
}
